module.exports = __webpack_public_path__ + "static/media/rv-banner.d7bdc378.jpg";